import { stringify } from 'query-string';
import { entityTypeToApiType } from 'helpers/mapEntityTypes';

import { EntityTypes } from 'context/entityContext';

export default function getEntityMetadataURL(
  type: EntityTypes,
  id: string,
  { showGrouped = true, ...params }: any
): string {
  return `/api/${entityTypeToApiType(type)}/${id}?${stringify({
    showGrouped,
    ...params,
  })}`;
}
